import { render, staticRenderFns } from "./room.vue?vue&type=template&id=4a5532da&scoped=true&"
import script from "./room.js?vue&type=script&lang=js&"
export * from "./room.js?vue&type=script&lang=js&"
import style0 from "./room.scss?vue&type=style&index=0&id=4a5532da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5532da",
  null
  
)

export default component.exports